import BlockComposition from "../modules/block-composition";

const Home = {
  init() {
    BlockComposition.init();
  },
};

export default Home;
